module.exports = function getResource(label) {
    const resources = { addPromo: 'Ajouter la promo' };
    return resources[label];
};
